// 所有特效都會放在這邊
const initState = {
  miniCartData: [],
  cart: [],
  cartListData: {
  },
  memberPoint: 0,
  isShowCouponModal: false,
  isShowMemberPointsModal: false,
  isShowCartDetailModal: false,
  isShowMarketingListModal: false,
  itemCouponList: [],
  cartCouponModalData: [],
  cartProductCoupon: [],
  isShowCartProductCouponModal: false,
  cartProductCouponModalData: {},
  // 購物小車(手機購物車頁)
  miniCartListData: {},
  cartPointOfServices: {},
  isShowCartPickUpDeliveryModal: false,
  isShowCartPromotionModal: false,
  cartPromotionData: [],
};

export function cartState(state = initState, action) {
  switch (action.type) {
    case 'UPDATE_MINICARTDATA_DATA': {
      return {
        ...state,
        miniCartData: action.payload,
      };
    }
    case 'UPDATE_CARTDATA_DATA': {
      // 命名有點奇怪，不知道什麼時候要用
      return {
        ...state,
        cart: action.payload,
      };
    }
    case 'UPDATE_CART_LIST_DATA': {
      return {
        ...state,
        cartListData: action.payload,
      };
    }
    case 'UPDATE_MINI_CART_LIST_DATA': {
      return {
        ...state,
        miniCartListData: action.payload,
      };
    }
    case 'UPDATE_IS_SHOW_CART_DETAIL_MODAL': {
      return {
        ...state,
        isShowCartDetailModal: action.payload,
      }
    }
    case 'UPDATE_IS_SHOW_MARKETING_LIST_MODAL': {
      return {
        ...state,
        isShowMarketingListModal: action.payload,
      }
    }
    case 'UPDATE_IS_SHOW_MEMBER_POINTS_MODAL': {
      return {
        ...state,
        isShowMemberPointsModal: action.payload,
      }
    }
    case 'UPDATE_IS_SHOW_COUPON_LIST_MODAL': {
      return {
        ...state,
        isShowCouponModal: action.payload,
      }
    }
    case 'GET_USE_COUPON': {
      return {
        ...state,
        cartCouponModalData: action.payload,
      }
    }
    case 'GET_MEMBER_POINTS': {
      return {
        ...state,
        memberPoint: action.payload,
      }
    }
    case 'GET_PRODUCT_COUPON': {
      const {
        index,
        productCoupon
      } = action.payload;
      const newCartProductCoupon = [...state.cartProductCoupon];
      newCartProductCoupon[index] = productCoupon;
      return {
        ...state,
        cartProductCoupon: newCartProductCoupon,
      }
    }
    case 'UPDATE_IS_SHOW_CART_PRODUCT_COUPON_MODAL': {
      return {
        ...state,
        isShowCartProductCouponModal: action.payload,
      }
    }
    case 'UPDATE_CART_PRODUCT_COUPON_MODAL_DATA': {
      return {
        ...state,
        cartProductCouponModalData: action.payload,
      }
    }
    case 'UPDATE_CART_POINT_OF_SERVICE_DATA': {
      const {
        entryNumber,
        storeData
      } = action.payload;

      let cartPointOfServices = {
        entryNumber,
        storeData
      }

      return {
        ...state,
        cartPointOfServices: cartPointOfServices,
      }
    }
    case "UPDATE_IS_SHOW_CART_PICKUP_MODAL": {
      return {
        ...state,
        isShowCartPickUpDeliveryModal: action.payload,
      }
    }
    case "UPDATE_IS_SHOW_CART_PROMOTION_MODAL": {
      return {
        ...state,
        isShowCartPromotionModal: action.payload,
      }
    }
    case "UPDATE_CART_PROMOTION_DATA": {
      return {
        ...state,
        cartPromotionData: action.payload,
      }
    }
    default:
      return state;
  }
}

export default cartState;
